import React, { useState, useEffect } from 'react';
import SearchDropdown from '../../atoms/searchdropdown/view';
import { getTaxes } from '../../../usecases/taxes-usecase';
import './style.css';

const TaxSearchDropdown = ({ onSelected, selected = undefined, taxes = null, taxType = null }) => {
  const [allTaxes, setAllTaxes] = useState([]);
  const [loading, setLoading] = useState(!taxes);
  const [error, setError] = useState(null);

  const formatTaxes = (data) => {
    const cleanData = (data || []).filter(item => item && item.message !== 'empty_array' && (taxType === null || taxType === undefined || item.tax_type === taxType));
    return cleanData.map(item => {
      const name = item.name || '';
      const hasPercent = name.includes('%');
      return {
        ...item,
        name: hasPercent ? name : `${name} - ${parseFloat(((item.value || 0) * 100).toFixed(2))}%`
      };
    });
  };

  useEffect(() => {
    if (taxes) {
      setAllTaxes(formatTaxes(taxes));
      setLoading(false);
      return;
    }

    const fetchTaxes = async () => {
      try {
        setLoading(true);
        const result = await getTaxes(1, 1000);
        // Accommodate possible API structure variations
        const data = result?.data?.data || result?.data || [];
        setAllTaxes(formatTaxes(data));
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchTaxes();
  }, [taxes, taxType]);

  if (loading) {
    return <div className="tax-search-dropdown-loading">Cargando impuestos...</div>;
  }

  if (error) {
    return <div className="error-text">Error: {error.message}</div>;
  }

  return (
    <div className="tax-search-container">
      <SearchDropdown
        placeholder={
          selected ?
            allTaxes.find(itm => itm.id === (selected?.tax_id || selected?.id))?.name
            : 'Selecciona un impuesto'
        }
        options={allTaxes}
        path='name'
        onSelect={onSelected}
      />
    </div>
  );
};

export default TaxSearchDropdown;
